export const CALCULATION = "CALCULATION";
export const SUMMARY_REPORT = "SUMMARY_REPORT";
export const MULTIPLE_STATE_ENTITY = "Multiple";

export const BUSY_CALCULATION_STATUS = ["QUEUED", "PROCESSING"];

export const TAX_FILE_SHEET_NAME = "Sheet0";

export const RECORD_ID_COLUMN = "RecordID";

export const XLSX_EXTENSION = ".xlsx";

export const MAX_INVALID_CELLS_SHOWN = 3;

export const AMOUNT_COLUMNS = [
  "InvoiceAmount",
  "CalculatedAmount",
  "TaxAmount",
  "TaxRate",
  "StateTaxableAmount",
  "CountyTaxableAmount",
  "CityTaxableAmount",
  "DistrictTaxableAmount",
  "ParishTaxableAmount",
  "StateTaxAmount",
  "CountyTaxAmount",
  "CityTaxAmount",
  "DistrictTaxAmount",
  "ParishTaxAmount",
] as const;
